export default "__VITE_ASSET__BJB6r1Ej__"